import React, { useState, useEffect } from "react";
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap";
import { FaUser, FaClock, FaInfoCircle, FaHome } from "react-icons/fa";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { getEmployees } from "../../components/Api/GmsEmployee";

const DefaultDashboard = () => {
  const [userInfo, setUserInfo] = useState({
    name: '',
    role: '',
    loginTime: '',
    sessionInfo: ''
  });

  useEffect(() => {
    const loadUserInfo = async () => {
      console.log('=== DASHBOARD DEBUG START ===');
      
      // Get user information from localStorage
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const authUser = JSON.parse(localStorage.getItem('authUser') || '{}');
      
      console.log('User data from localStorage:', user);
      console.log('AuthUser data from localStorage:', authUser);
      console.log('AuthUser.employeeId:', authUser.employeeId);
      console.log('AuthUser.userName:', authUser.userName);
      
      // Get current time for login time
      const now = new Date();
      const loginTime = now.toLocaleString();
      
      let displayName = authUser.userName || user.user_UserName || user.user_Name || 'User';
      console.log('Initial display name:', displayName);
      
      // Check for employeeId in both authUser and user objects
      const employeeId = authUser.employeeId || user.user_EmployeeId;
      console.log('EmployeeId from authUser:', authUser.employeeId);
      console.log('user_EmployeeId from user:', user.user_EmployeeId);
      console.log('Final employeeId to use:', employeeId);
      
      // If user has employeeId, try to get employee name
      if (employeeId) {
        console.log('EmployeeId found, attempting to fetch employee data...');
        try {
          console.log('Calling getEmployees() API...');
          const employees = await getEmployees();
          console.log('Employees API response:', employees);
          console.log('Number of employees returned:', employees ? employees.length : 'null/undefined');
          
          if (employees && employees.length > 0) {
            console.log('First employee sample:', employees[0]);
            const employee = employees.find(emp => emp.employee_Id === employeeId);
            console.log('Searching for employee with ID:', employeeId);
            console.log('Found employee:', employee);
            
            if (employee) {
              const newDisplayName = employee.employee_NameEn || employee.employee_NameAr || displayName;
              console.log('Employee name fields:', {
                employee_NameEn: employee.employee_NameEn,
                employee_NameAr: employee.employee_NameAr
              });
              displayName = newDisplayName;
              console.log('Updated display name to:', displayName);
            } else {
              console.log('Employee not found in the list. Available employee IDs:', employees.map(emp => emp.employee_Id));
            }
          } else {
            console.log('No employees returned from API');
          }
        } catch (error) {
          console.error('Error fetching employee data:', error);
          console.log('API call failed, keeping display name as:', displayName);
        }
      } else {
        console.log('No employeeId found, using username:', displayName);
      }
      
      console.log('Final display name before setting state:', displayName);
      
      const finalUserInfo = {
        name: displayName,
        role: user.user_Role || authUser.role || 'Employee',
        loginTime: loginTime,
        sessionInfo: `Session active since ${loginTime}`
      };
      
      console.log('Setting userInfo state with:', finalUserInfo);
      setUserInfo(finalUserInfo);
      
      console.log('=== DASHBOARD DEBUG END ===');
    };
    
    loadUserInfo();
  }, []);

  console.log('Rendering dashboard with userInfo:', userInfo);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumb title="Dashboard" breadcrumbItem="Welcome" />
        
        <Row>
          {/* Welcome Message */}
          <Col lg="12">
            <Card>
              <CardBody>
                <div className="text-center">
                  <FaHome size={48} className="text-primary mb-3" />
                  <h3 className="mb-3">Welcome to GMS System</h3>
                  <p className="text-muted">
                    You are logged in successfully. This is your personalized dashboard.
                  </p>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          {/* User Profile Information */}
          <Col lg="6">
            <Card>
              <CardBody>
                <CardTitle className="d-flex align-items-center">
                  <FaUser className="me-2 text-primary" />
                  Profile Information
                </CardTitle>
                <div className="mt-3">
                  <p><strong>Name:</strong> {userInfo.name}</p>
                  <p><strong>Role:</strong> {userInfo.role}</p>
                  <p><strong>Status:</strong> <span className="badge bg-success">Active</span></p>
                </div>
              </CardBody>
            </Card>
          </Col>

          {/* System Status */}
          <Col lg="6">
            <Card>
              <CardBody>
                <CardTitle className="d-flex align-items-center">
                  <FaClock className="me-2 text-primary" />
                  System Status
                </CardTitle>
                <div className="mt-3">
                  <p><strong>Login Time:</strong> {userInfo.loginTime}</p>
                  <p><strong>Session:</strong> <span className="badge bg-info">Active</span></p>
                  <p><strong>System:</strong> <span className="badge bg-success">Online</span></p>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          {/* Additional Information */}
          <Col lg="12">
            <Card>
              <CardBody>
                <CardTitle className="d-flex align-items-center">
                  <FaInfoCircle className="me-2 text-primary" />
                  System Information
                </CardTitle>
                <div className="mt-3">
                  <p className="text-muted">
                    This is your default dashboard. You can access the available features through the sidebar menu.
                    If you need access to specific modules, please contact your system administrator.
                  </p>
                  <div className="mt-3">
                    <h6>Available Actions:</h6>
                    <ul className="list-unstyled">
                      <li>• Navigate through the sidebar menu to access available features</li>
                      <li>• Contact support if you need assistance</li>
                    </ul>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default DefaultDashboard;
